export default function WhatsAppButton() {
  const whatsappNumber = '+56994347092';
  const whatsappMessage = 'Hola, me gustaría hacer una consulta';

  return (
    <a
      href={`https://wa.me/56994347092?text=${encodeURIComponent(whatsappMessage)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 flex items-center justify-center bg-green-600 hover:bg-green-700 text-white rounded-full shadow-2xl hover:scale-110 transition-all cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      <span className="absolute right-full mr-4 bg-stone-800 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        ¿Necesitas ayuda?
      </span>
    </a>
  );
}
